const storageUrl = process.env.REACT_APP_STORAGE_URL;
const cdnUrl = process.env.REACT_APP_CDN_URL;
const goCdnUrl = process.env.REACT_APP_GO_CDN_URL;
const soundMasterCdnUrl = process.env.REACT_APP_SOUND_MASTER_CDN_URL;

type ToCDNUrlOption = {
  enableGoCdn: boolean;
  cdnUrl?: string;
};

const toCDNUrl = (
  baseUrl: string | null,
  options: ToCDNUrlOption = { enableGoCdn: false }
): string => {
  if (!baseUrl || !storageUrl || !cdnUrl || !goCdnUrl) return "";

  if (options.enableGoCdn) {
    return replacePrefix(baseUrl, [storageUrl, cdnUrl], goCdnUrl);
  } else if (options.cdnUrl) {
    return replacePrefix(baseUrl, [storageUrl, cdnUrl], options.cdnUrl);
  } else {
    return replacePrefix(baseUrl, [storageUrl], cdnUrl);
  }
};

const replacePrefix = (
  url: string,
  searchPrefixes: string[],
  replaceValue: string
): string => {
  let v = url;
  for (const searchPrefix of searchPrefixes) {
    if (v.startsWith(searchPrefix)) {
      v = v.replace(searchPrefix, replaceValue);
    }
  }
  return v;
};

export const isCDNUrl = (
  url: string,
  options: { cdnUrl?: string } = {}
): boolean => {
  return (
    (!!storageUrl && url.startsWith(storageUrl)) ||
    (!!cdnUrl && url.startsWith(cdnUrl)) ||
    (!!goCdnUrl && url.startsWith(goCdnUrl)) ||
    (!!soundMasterCdnUrl && url.startsWith(soundMasterCdnUrl)) ||
    (!!options.cdnUrl && url.startsWith(options.cdnUrl))
  );
};

type HostKind = "cloudflare" | "google" | "external" | "empty";

export const kindofHost = (
  url: string,
  options: { cdnUrl?: string } = {}
): HostKind => {
  const effectiveCdnUrl = options.cdnUrl || cdnUrl;

  if (!url) {
    return "empty";
  } else if (effectiveCdnUrl && url.startsWith(effectiveCdnUrl)) {
    return "cloudflare";
  } else if (goCdnUrl && url.startsWith(goCdnUrl)) {
    return "google";
  } else {
    return "external";
  }
};

export default toCDNUrl;
